import { Injectable } from '@angular/core';
import {GenericService} from "../../commons/generic.service";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs/internal/Observable";
import {DependentesServidorDto} from "../../components/recadastramento-aba7/dependentesServidor.dto";
import {TipoParentescoDto} from "../../model/tipoParentesco.dto";
import {ArquivoBlobDTO} from "../../model/arquivoBlob.dto";
import {PlanoDeSaudeServidorDto} from "../../components/recadastramento-aba10/plano-de-saude-servidor.dto";
import {ConcessaoAuxDto} from "../../components/recadastramento-aba10/concessaoAux.dto";
import {AuxilioSaudeFormDto} from "../../components/recadastramento-aba10/AuxilioSaudeForm.dto";

@Injectable({
  providedIn: 'root'
})
export class PlanoDeSaudeServidorAba10Service extends GenericService {

  private basePath = 'api/v1';
  private path = '/despesa-anual';
  url = environment.url;

  constructor(http: HttpClient) {
    super(http);
  }

  getPlanos(): Observable<PlanoDeSaudeServidorDto[]> {
    return this.http.get<PlanoDeSaudeServidorDto[]>(this.url + this.basePath + this.path + "/servidor/planos");
  }

  getConcessoes(plano: string): Observable<ConcessaoAuxDto[]> {
    return this.http.get<ConcessaoAuxDto[]>(this.url + this.basePath + this.path + "/servidor/concessoes/"+ plano);
  }

  getArquivos(codigoPlano: string, mes: string): Observable<ArquivoBlobDTO> {
    const options = {
      responseType: 'blob' as 'json'
    };

    return this.http.get<ArquivoBlobDTO>(this.url + this.basePath +'/visualizar_comprovante'+ this.path + '/servidor/' + codigoPlano +'/' + mes, options);
  }

  deleteComprovante(codigoPlano: string, mes: string): Observable<any> {

    return this.http.put<any>(this.url + this.basePath +'/comprovante-deletar'+ this.path + '/servidor/' + codigoPlano +'/' + mes, {});
  }

  uploadComprovante(file: File, auxilioSaude: AuxilioSaudeFormDto) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('auxilioSaude', JSON.stringify(auxilioSaude));

    return this.patchMethodFile(this.url + this.basePath + '/upload_comprovante/despesa-anual-servidor', formData);
  }

}
